/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'water-drop-blue': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M64 8c0 0 40 40 40 72 0 22.1-17.9 40-40 40S24 102.1 24 80C24 48 64 8 64 8z" fill="#409EFF" stroke="#FFFFFF" stroke-width="8" stroke-linejoin="round"/><path pid="1" d="M64 8c0 0 40 40 40 72 0 22.1-17.9 40-40 40S24 102.1 24 80C24 48 64 8 64 8z" fill="none" stroke="#000000" stroke-width="3" stroke-linejoin="round"/>'
  }
})